<template>
    <div>
      <domain-list></domain-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  